import { http } from "../http";

export const getByMobileNumber = ( {queryKey}: any) => {
  return http.get(`/registration-form/trainee/${queryKey[1]}`);
};

export const submitFeedback = (body: any) => {
  return http.post("/feedback", body);
};